import { ChevronDown } from 'lucide-react'
import { Bagian } from './Bagian'

/**
 * Pertanyaan yang benar-benar ditanyakan calon user, dijawab apa adanya.
 *
 * Beberapa jawaban menyebut batas produk dengan sengaja: halaman depan yang
 * menyembunyikan "komputer harus menyala" akan menghasilkan user yang kecewa
 * pada minggu pertama, dan itu lebih mahal daripada kehilangan satu pendaftaran.
 */
const TANYA = [
  {
    q: 'Does Orisini use the official Pinterest, Threads, or Instagram APIs?',
    a: "None of them. The agent on your computer opens the platform and presses publish, exactly as you would yourself. That's why there is no API key for you to manage, and no access to grant to our servers.",
  },
  {
    q: 'Does Orisini store my platform passwords?',
    a: "No. Platform logins happen inside the Chrome profile on your computer, and the session stays there. The only thing stored on Orisini's servers is a device token, which you can revoke at any time from the devices page.",
  },
  {
    q: 'Does my computer have to be on?',
    a: "Yes, when the publish time arrives. If the computer is off, the queue waits and the post publishes as soon as the agent comes back on. Orisini's servers only hold the schedule.",
  },
  {
    q: 'Which platforms can be used today?',
    a: 'Pinterest and Instagram already publish real posts. Threads is being built. Facebook and TikTok are still only planned.',
  },
  {
    q: 'Do I pay separately for each platform?',
    a: 'No. One plan covers every platform. The limits — posts per month, connected accounts, and generated content — are totals across all of them.',
  },
  {
    q: 'Can it post video?',
    a: "Instagram Reels, yes — tested on a real account. Video pins on Pinterest haven't been tested yet, and we won't call that a feature until they are.",
  },
  {
    q: 'What if a post fails to publish?',
    a: "The status is visible in the queue, not lost without word. Worth knowing: a failed attempt can leave a draft on your Pinterest account, and there is no automatic cleanup for that.",
  },
  {
    q: 'How do I pay?',
    a: 'Via QRIS. After paying, verification is manual, so the subscription may activate some time after payment — not instantly.',
  },
]

export function BagianTanya() {
  return (
    <Bagian
      id="faq"
      judul="What people usually ask first"
      keterangan="Including the things that don't favor us."
    >
      <div className="border-t border-border">
        {TANYA.map((t) => (
          <details key={t.q} className="group border-b border-border">
            <summary className="flex cursor-pointer list-none items-start justify-between gap-6 rounded-sm py-5 text-left font-medium marker:content-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background [&::-webkit-details-marker]:hidden">
              <span className="text-pretty">{t.q}</span>
              <ChevronDown
                aria-hidden
                className="mt-0.5 size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180"
              />
            </summary>
            <p className="max-w-2xl pb-6 text-sm leading-relaxed text-muted-foreground">{t.a}</p>
          </details>
        ))}
      </div>
    </Bagian>
  )
}
